@if(integration())
{
  <div>
    <div class="d-flex flex-row gap-2">
      <app-lt-switch onLabel="XML" offLabel="JS" [checked]="xmlSelected()" (toggleChange)="saveData($event)"></app-lt-switch>

      @if(!xmlSelected() && integration().javaScript.length > 0 && destinationEndpoints().length > 0)
      {
        <div class="inline">
          <mat-button-toggle-group class="lt-toggle" (change)="switchJavaScript($event.value)" [hideSingleSelectionIndicator]="true">
            @for(j of integration().javaScript; track $index)
            {
              <mat-button-toggle [value]="j" [checked]="j === javaScript">
                {{ getEndpointName(j.destinationEndpointId) }}
              </mat-button-toggle>
            }
          </mat-button-toggle-group>

          @if(checkAccess(['LOSTalker.Admin']) && this.integration().javaScript.length < 3)
          {
            <mat-button-toggle-group [hideSingleSelectionIndicator]="true">
              <mat-button-toggle (click)="addNewJavaScript()">+</mat-button-toggle>
            </mat-button-toggle-group>
          }

        </div>
      }
    </div>


    @if(xmlSelected() || integration().javaScript.length > 0)
    {
      <app-monaco-editor #monaco
        (textChange)="monacoData = $event"
        [editorData]="monacoData"
        [editAccess]="checkAccess(['LOSTalker.Admin'])"
        [lang]="lang" />
    }

    @if(xmlSelected())
    {
      <div class="integration-commands">
        <button matButton="outlined" (click)="goBack()">Back To Clients</button>
        @if(checkAccess(['LOSTalker.Admin']))
        {
          <button matButton="outlined" color="primary" [disabled]="savingInformation()" (click)="updateIntegration()">Save Changes</button>
          <button matButton="outlined" [disabled]="savingInformation()" (click)="handleDeleteIntegration()">Delete Integration</button>
          @if(!isGenericIntegration())
          {
            <button matButton="outlined" [disabled]="savingInformation()" (click)="createGenericIntegration()">Convert to Generic</button>
            <mat-checkbox [ngModel]="convertCreateNew()" (ngModelChange)="convertCreateNew.set($event)" class="checkbox-padding">
              Create new integration
            </mat-checkbox>
          }
          @else if (!isAPIIntegration()) {
            <button matButton="outlined" [disabled]="savingInformation()" (click)="createAPIIntegration()">Convert to API</button>
          }
        }
      </div>
    }
    @else
    {
      <div class="my-1">
        @if(integration().javaScript.length > 0)
        {
          <div class="integration-commands">
            <button matButton="outlined" (click)="goBack()">Back To Clients</button>
            @if(checkAccess(['LOSTalker.Admin']))
            {
              <button matButton="outlined" [disabled]="savingInformation()" (click)="updateIntegration()" color="primary">Save Changes</button>
              <button matButton="outlined" [disabled]="savingInformation()" (click)="handleDeleteIntegration()">Delete Integration</button>
              <button matButton="outlined" [disabled]="savingInformation()" (click)="deleteJavaScript()">Delete JavaScript</button>
            }
          </div>
        }
        @else {
          <div class="inline">
            <div>There are no existing Custom JavaScript for {{integration().name}}. Would you like to create one
              for CSDataSwap or Surefire3?
            </div>
            @if(checkAccess(['LOSTalker.Admin']))
            {
              <button matButton="outlined" [disabled]="savingInformation()" (click)="addNewJavaScript()">+</button>
            }
          </div>
        }

      </div>
    }

  </div>
}


<ng-template #addJsDialog>
  <h2 matDialogTitle>Add JavaScript to Integration</h2>
  <mat-dialog-content>
    <mat-form-field appearance="fill">
      <mat-select [(value)]="destNameSelected">
        @for(destName of availableDestinations; track $index)
        {
          <mat-option [value]="destName">{{destName}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton matDialogClose [disabled]="!destNameSelected" (click)="selectNewJavaScript(destNameSelected)">Create</button>
    <button matButton matDialogClose>Close</button>
  </mat-dialog-actions>
</ng-template>
